const locales = {
  'wrong': {
    'txt-wrong1': 'กรุณากรอกอีเมลและรหัสผ่านของคุณ',
    'txt-wrong2': 'กรุณาใส่อีเมลให้ถูกต้อง',
    'txt-wrong3': 'อีเมลหรือรหัสผ่านไม่ถูกต้อง กรุณาลองอีกครั้ง',
    'txt-wrong4': 'กรุณากรอกอีเมลของคุณ',
    'txt-wrong5': 'กรุณากรอกอีเมลให้ถูกต้อง',
    'txt-wrong6': 'ไม่พบอีเมลของคุณ',
    'txt-wrong7': 'กรุณาใส่รหัสผ่านของคุณมากกว่า 6 ตัวอักษรใช้ทั้งตัวเลขและตัวอักษร',
    'txt-wrong8': 'การยืนยันรหัสผ่านไม่ตรงกัน',
    'txt-wrong9': 'รหัสผ่านไม่ถูกต้อง',
    'txt-wrong10': 'กรุณาใส่รหัสผ่านของคุณมากกว่า 6 ตัวอักษร ใช้ทั้งตัวเลขและตัวอักษร (A-Z, a-z, 0-9)',
    'txt-wrong11': 'กรุณากรอกข้อมูลให้ครบ' ,
    'txt-wrong12': 'กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง',
    'txt-wrong13': 'CAPTCHA ไม่ถูกต้อง',
    'txt-wrong14': 'มีอีเมลนี้ในระบบแล้ว',
    'txt-wrong15': 'กรุณากรอกรหัสผ่านของคุณ' ,
    'txt-wrong16': 'รหัสผ่านใหม่ต้องไม่ตรงกับรหัสผ่านปัจจุบัน' ,
    'txt-wrong17': 'กรุณากรอกรหัสบริษัทขนส่ง' ,
    'txt-wrong18': 'กรุณากรอกชื่อบริษัทขนส่ง' ,
    'txt-wrong19': 'กรุณาเลือกบริษัทขนส่ง' ,
    'txt-wrong20': 'มีข้อมูลอยู่แล้วในระบบ' ,
    'txt-wrong21': 'กรุณาแนบไฟล์ (ชนิดของไฟล์ .png, .pdf, .jpg, .jpeg และ .zip) และขนาดไฟล์ไม่เกิน 2 MB.' ,
    'txt-wrong22': 'กรุณากรอกอีเมล @dhas เท่านั้น' ,
    'txt-wrong23': 'กรุณากรอกอีเมล' ,
    'txt-wrong24': 'ไฟล์มีปัญหา กรุณาแนบไฟล์ใหม่' ,
    'txt-wrong25': 'กรุณากรอกเลขพัสดุ' ,

    
    
  },
  
}
export default locales